import UserAuth from "components/AuthGaurd/UserAuth";
import ActivationCodeSection from "components/dashboard/ActivationCodeSection";
import DashboardHeroSection from "components/dashboard/DashboardHeroSection";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import React from "react";

const ActivationCode = () => {
  return (
    <UserAuth>
      <header>
        <Header admin={true} />
      </header>

      {/* hero section */}
      <DashboardHeroSection title="Activation Code">
        <ActivationCodeSection />
      </DashboardHeroSection>

      <footer className="tw-flex">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default ActivationCode;
